import qs from 'query-string';
import { get, post, del } from './baseApi';

export const VetCustomerApi = {
    fetch: (query) => get(`/vets/customers?${qs.stringify(query)}`),
    accept: (id) => post(`/vets/customers/${id}`),
    login: (data) => post(`/vets/customers/login`, data),
    delete: (id) => del(`/vets/customers/${id}`),
};
